<template>
  <div
    class="export"
    @mousemove="googleTranslateElementInit"
    v-if="assinaturas.homologacao[0].status === 2"
  >
    <div v-if="is_loading">
      <LoadingTranslation />
    </div>
    <div>
      <div id="google_translate_element"></div>
      <page class="page-person" size="A4">
        <div>
          <Cabecalho :codigo_rrim="data.InforGeral.ID" />
          <main>
            <InforGeral :dataInforGeral="data.InforGeral" />
            <Produtos :dataProdutos="data.produto" />
            <Cavidade :dataMoldeAberto="data.InforGeral.molde_aberto[0]" />
            <InforGeralMolde
              :dataMoldeFechado="data.InforGeral.molde_fechado[0]"
            />
            <Checklist
              :DataChecklist="data.InforGeral.molde_fechado[0].checklist"
            />
          </main>
        </div>
        <footer>
          <Assinaturas :id="data.InforGeral.ID" />
          <FooterImpresso />
        </footer>
      </page>

      <page class="page-person" size="A4">
        <div>
          <Cabecalho :codigo_rrim="data.InforGeral.ID" />
          <main>
            <MoldeFechadoImgs :data="data.ImagesRRIM[0]" />
          </main>
        </div>
        <footer>
          <FooterImpresso />
        </footer>
      </page>

      <page class="page-person" size="A4">
        <div>
          <Cabecalho :codigo_rrim="data.InforGeral.ID" />
          <main>
            <AberturaDeEmbalagemImgs :data="data.ImagesRRIM[0]" />
            <MoldeAbertoImgs :data="data.ImagesRRIM[0]" />
          </main>
        </div>
        <footer>
          <FooterImpresso />
        </footer>
      </page>

      <page class="page-person" size="A4">
        <div>
          <Cabecalho :codigo_rrim="data.InforGeral.ID" />
          <main>
            <div>
              <div v-if="data.ListSpareParts.length > 0" class="main-sp">
                <div class="categorias">LISTA DE PEÇAS DE REPOSIÇÃO DO MOLDE</div>
                <div class="spare-parts">
                  <table>
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Descrição</th>
                        <th>Quantidade</th>
                        <th>Observações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="l in data.ListSpareParts" :key="l.ID">
                        <td class="td-center">
                          <div class="img-exp">
                            <div class="conteudo">
                              <img
                                alt="Não Aplicável"
                                :src="this.$store.state.ImgURL + l.PATH_IMG + '.webp'"
                              />
                            </div>
                          </div>
                        </td>
                        <td>{{ l.DESCRIPTION }}</td>
                        <td>{{ l.QUANTIDADE }}</td>
                        <td>{{ l.OBSERVACAO }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-else class="main-alert">
                <div class="alert-sp">
                  O MOLDE NÃO ACOMPANHA SPARE PARTS
                </div>
              </div>
            </div>
          </main>
        </div>
        <footer>
          <FooterImpresso />
        </footer>
        <div class="btnImprimir">
          <button @click="printDocument">Imprimir</button>
        </div>
      </page>
    </div>
  </div>
  <div v-else>Exportação não disponivel</div>
</template>

<script>
import Cabecalho from "./modules/page_rrim/cabecalho.vue";
import InforGeral from "./modules/page_rrim/informacoes_gerais.vue";
import Produtos from "./modules/page_rrim/produtos.vue";
import Cavidade from "./modules/page_rrim/cavidade.vue";
import InforGeralMolde from "./modules/page_rrim/informacoes_gerais_molde.vue";
import Checklist from "./modules/page_rrim/checklist.vue";
import Assinaturas from "./modules/page_rrim/assinaturas.vue";
import FooterImpresso from "./modules/page_rrim/FooterImpresso.vue";
import AberturaDeEmbalagemImgs from "./modules/page_images_rrim/abertura _de_embalagem.vue";
import MoldeFechadoImgs from "./modules/page_images_rrim/molde_fechado.vue";
import MoldeAbertoImgs from "./modules/page_images_rrim/molde_aberto.vue";
import ListaDeSpareParts from "./modules/page_lsp/lista_SpareParts.vue";
import { FindRRimHomologada } from "../../controllers/RRIM/FindRRimHomologada";
import { GetFindDataByIdRRIM } from "../../controllers/RRIM/GetFindDataByIdRRIM";
import LoadingTranslation from "../LoadingTranslation.vue";
import axios from "axios";

export default {
  name: "exportRRIM",
  components: {
    Cabecalho,
    InforGeral,
    ListaDeSpareParts,
    Produtos,
    Cavidade,
    InforGeralMolde,
    Checklist,
    Assinaturas,
    AberturaDeEmbalagemImgs,
    MoldeFechadoImgs,
    MoldeAbertoImgs,
    FooterImpresso,
    LoadingTranslation,
  },

  async created() {
    let id = this.$route.query.id;
    if (id > 0) {
      const res = await GetFindDataByIdRRIM(id);
      this.data = res.data;

      console.log("dataRRIM", this.data);

      this.assinaturas = await FindRRimHomologada(this.data.InforGeral.ID);
    }
  },
  data() {
    return {
      data: "",
      assinaturas: null,
      is_loading: false,
    };
  },
  mounted() {
    this.googleTranslateElementInit();
  },
  methods: {
    googleTranslateElementInit() {
      new google.translate.TranslateElement(
        { pageLanguage: "pt", includedLanguages: "pt,en" },
        "google_translate_element"
      );
    },
    printDocument() {
      window.print();
    },
  },
};
</script>

<style>
* {
  margin: 0;
  box-sizing: 0;
  padding: 0;
  font-family: Arial, Helvetica, sans-serif;
}

/*google translate Dropdown */
#google_translate_element {
  flex: flex;
  flex-wrap: wrap;
  top: 0 !important;
  position: relative !important;
}

#google_translate_element select {
  background: #ffffff;
  color: #474747;
  border: none;
  border-radius: 3px;
  padding: 6px 8px;
  box-shadow: rgb(50 50 93 / 25%) 0px 6px 12px -2px,
    rgb(0 0 0 / 30%) 0px 3px 7px -3px;
}

/*google translate link | logo */
.goog-logo-link {
  display: none !important;
}
.goog-te-gadget {
  color: transparent !important;
}
.goog-te-banner-frame {
  display: none !important;
}
#goog-gt-tt,
.goog-te-balloon-frame {
  display: none !important;
}
.goog-text-highlight {
  background: none !important;
  box-shadow: none !important;
}
#google_translate_element {
  position: fixed;
  top: 6rem;
  left: 0.5rem;
}

.btnTranslate {
  top: 3rem;
  position: fixed;
  width: fit-content;
  height: 2rem;
  align-items: center;
  gap: 0.3rem;
  justify-content: center;
  display: flex;
  background: var(--white);
  font-weight: 700;
  border-radius: 0.2rem;
  padding: 0 1rem;
  margin: 0.5rem;
  cursor: pointer;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}
.btnTranslate:hover {
  filter: brightness(0.6);
}
.btnTranslate img {
  width: 1rem;
  height: fit-content;
}
.btnTranslate span {
  width: 50px;
  height: 50px;
  line-height: 50px;
  padding: 0.5rem;
  background: color("b-gray");
  border-radius: 5px;
  cursor: pointer;
}

.export page {
  background: var(--white);
  display: block;
  margin: 0 auto;
  margin-bottom: 2cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}
.export page[size="A4"] {
  width: 21cm;
  min-height: 27.55cm;
  display: flex;
  flex-direction: column;
  padding: 2rem;
}
.page-person {
  justify-content: space-between;
}
.export main {
  height: 100%;
}
.export .btnImprimir button {
  width: 15%;
  padding: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.2rem;
  cursor: pointer;
  border-radius: 1rem;
  border: none;
  background: #b1b1b1;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

@media print {
  @page {
    size: A4;
    margin: 10mm;
  }
  .btnTranslate,
  #google_translate_element,
  .btnImprimir {
    display: none !important;
  }
  body {
    margin: 0;
    background: white;
  }
  .export {
    box-shadow: none;
    background: white;
  }
  .export page {
    width: 100%;
    max-width: 210mm;
    min-height: 297mm;
    margin: 0 auto;
    border: 1px solid #000;
    page-break-after: always;
  }
  .export page:last-child {
    page-break-after: auto;
  }
}

/* Categorias */
.categorias {
  width: 100%;
  height: 30px;
  display: flex;
  padding: 0 1rem;
  align-items: center;
  font-size: 1rem;
  border-top: 2px solid #636363;
  border-bottom: 2px solid #636363;
  color: #636363;
  font-weight: 600;
}
.sub-categorias {
  width: 100%;
  height: 20px;
  background: var(--red);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  background: var(--grayBody);
}

/* Rodape de assinaturas */
.assinaturas {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.assinaturas .items {
  display: flex;
}
.assinaturas .items div {
  display: flex;
  justify-content: center;
  width: 100%;
}
.export footer .assinaturas .items .m75,
.items .m75 {
  width: 100%;
}
.items .items-row .m25 {
  width: 25%;
}
.assinaturas .items .assinatura {
  height: 100%;
}
.assinaturas .items .campos {
  align-items: center;
}

/* MAIN */
.m25,
.items .m25 {
  width: 125%;
}
.items {
  display: flex;
  justify-content: center;
  width: auto;
  height: auto;
  background: var(--white);
  font-size: 12px;
  text-align: center;
}
.items div {
  width: 100%;
}
.items-row {
  display: flex;
  width: 100%;
  background: var(--white);
  font-size: 12px;
  align-items: center;
  justify-content: center;
}
.items-row div {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.item-title {
  background: #ededed;
  padding: 0.3rem;
}

/* MAIN - INFORMAÇÕES GERAIS DO MOLDE */
.infor-geral-molde div .row {
  display: flex;
  flex-direction: row;
}
.infor-geral-molde .items-columm {
  width: 100%;
  height: auto;
  background: var(--white);
  font-size: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
}

/* MAIN - CHECKLIST */
.checklist-eng .items table {
  width: 100%;
  font-size: 11px;
  border-collapse: collapse;
  border-spacing: 0;
}
.checklist-eng .items table tbody th {
  padding-left: 2px;
  min-width: 26vh;
}
.checklist-eng .items table tbody tr {
  text-align: left;
  border-top: 1px solid var(--black);
}
.checklist-eng .items table tbody tr td {
  padding-top: 3px;
  padding-right: 3px;
}
.checklist-eng .items table {
  width: 100%;
  font-size: 10px;
}

/*CLASS BORDER */
.bd-top {
  border-top: 1px solid #636363;
}
.bd-bottom {
  border-bottom: 1px solid #636363;
}
.bd-right {
  border-right: 1px solid #636363;
}
.margin-mn {
  padding-left: 5px;
  align-items: flex-start;
}
.items-row-img {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.img-exp {
  display: flex;
  flex-direction: column;
  margin-top: 4px;
}
.img-exp .conteudo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.img-exp .conteudo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4.68cm;
  height: 5.42cm;
  color: #636363;
}
.img-exp .legenda {
  padding: 0.8rem 0px;
  border-top: 1px solid #636363;
  font-size: 11px;
  display: flex;
  justify-content: center;
}
.spare-parts table tbody img {
  width: 100%;
}
.spare-parts table tbody td .img-exp {
  width: 4.42cm;
  height: 3.68cm;
}
.spare-parts table tbody td {
  text-align: center;
  justify-content: center;
}
.spare-parts table {
  width: 100%;
}
.td-center {
  display: flex;
  justify-content: center;
}
.alert-sp {
  color: var(--red);
  border: 2px solid var(--red);
  height: 30px;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-sp {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.main-alert {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>